'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AntdApp from 'antd/es/app';
import { useLayoutEffect } from 'react';
import { AntdAppContainer } from './styles';
let currentAppApi;
const getCurrentAppApi = () => {
    if (!currentAppApi) {
        throw new Error('AntdAppProvider must be mounted before using Ant Design feedback APIs');
    }
    return currentAppApi;
};
const createApiProxy = (key) => new Proxy({}, {
    get: (_target, property) => {
        if (property === Symbol.toStringTag)
            return 'AntdAppApi';
        const api = getCurrentAppApi()[key];
        const value = Reflect.get(api, property);
        return typeof value === 'function' ? value.bind(api) : value;
    },
});
export const antdMessage = createApiProxy('message');
export const antdNotification = createApiProxy('notification');
export const antdModal = createApiProxy('modal');
const AntdAppApiBridge = () => {
    const appApi = AntdApp.useApp();
    useLayoutEffect(() => {
        currentAppApi = appApi;
        return () => {
            if (currentAppApi === appApi)
                currentAppApi = undefined;
        };
    }, [appApi]);
    return null;
};
export const AntdAppProvider = ({ children }) => (_jsxs(AntdAppContainer, { children: [_jsx(AntdAppApiBridge, {}), children] }));
